import {
  GetCreditsFromPremiumPlanResponse,
  getCreditsFromPremiumPlan,
} from '@otter-ai/recall-client';
import { SECOND_MS } from '#constants';
import { QueryOptions, QueryResult } from './types';

type CreditsFromPremiumPlanQueryParams = {
  coupon_code?: string;
};

const createCreditsFromPremiumPlanQueryKey = (
  params: CreditsFromPremiumPlanQueryParams = {},
) => ['creditsFromPremiumPlan', params] as const;

type CreditsFromPremiumPlanQueryKey = ReturnType<
  typeof createCreditsFromPremiumPlanQueryKey
>;

const staleTime = SECOND_MS * 10;

export function creditsFromPremiumPlanQueryCreator(
  params: CreditsFromPremiumPlanQueryParams = {},
  additionalOptions: QueryOptions<
    GetCreditsFromPremiumPlanResponse,
    CreditsFromPremiumPlanQueryKey
  > = {},
): QueryResult<
  GetCreditsFromPremiumPlanResponse,
  CreditsFromPremiumPlanQueryKey
> {
  return {
    staleTime,
    queryKey: createCreditsFromPremiumPlanQueryKey(params),
    queryFn: async () => {
      const response = await getCreditsFromPremiumPlan({
        throwOnError: true,
        query: params,
      });
      return response.data;
    },
    ...additionalOptions,
  };
}
